<template>
  <div :class="{'row': screenSizeId >= 3, [classes]: true}" v-if="onReady">
    <ks-spinner ref="ref_loading_data_nav"/>
    <slot></slot>
    <ks-button v-if="showDefaultFilterSubmit" color="primary" size="sm" label="Submit" classIcon="fas fa-angle-double-right fa-fw" @onClick="filter()" />
    <ks-button v-if="showDefaultFilterClear" color="secondary" classes="ml-1" size="sm" label="Clear" classIcon="fas fa-redo fa-fw" @onClick="clear()" />
    <div :class="{'col-12': screenSizeId >= 3}">
      <div class="" v-if="showNavigation">
        <small class="text-muted">
          Page {{ current_page + 1 }} of {{ data_provider_ref.total_pages }} | {{ data_provider_ref.total_records }} Records
        </small>
      </div>
      <div class="d-flex flex-row justify-content-between flex-nowrap" style="width: 100%;">

        <div class="" v-if="showNavigation && pageSizes.length > 0">
          <div class="input-group">
            <div class="input-group-prepend" v-if="screenSizeId >= 3">
              <label class="input-group-text">Page Size</label>
            </div>

            <select :id="'pagination-pages-'+_uid" class="custom-select" v-model="page_size" @change="changePageSize">
              <option v-for="(size, index) in pageSizes" :key="'pagination-option-'+index" :value="size">
                {{ size }}
              </option>
            </select>
          </div>
        </div>
        <div v-if="showNavigation">
          <div class="btn-group w-100">
            <button class="btn btn-outline-secondary" @click.prevent="firstPage" :disabled="!prevPageEnable">
              <i class="fas fa-angle-double-left fa-fw"></i>
            </button>
            <button class="btn btn-outline-secondary" @click.prevent="prevPage" :disabled="!prevPageEnable">
              <i class="fas fa-angle-left fa-fw"></i>
            </button>
            <button class="btn btn-outline-secondary" @click.prevent="nextPage" :disabled="!nextPageEnable">
              <i class="fas fa-angle-right fa-fw"></i>
            </button>
            <button class="btn btn-outline-secondary" @click.prevent="lastPage" :disabled="!nextPageEnable">
              <i class="fas fa-angle-double-right fa-fw"></i>
            </button>
          </div>
        </div>
      </div>
      <div v-if="showErrors && errs.length > 0" style="padding-bottom: 10px;">
        <li class="text-danger" v-for="error of errs">{{ error.error_text ? error.error_text : "Unexpected error, Please Check" }}</li>
      </div>

      <div :class="{'row': screenSizeId >= 3}">
        <div class="col-12 col-md-auto mb-2 order-md-4 order-4 d-flex flex-row justify-content-end flex-nowrap">
          <ks-multi-sort v-if="showMultiSort" :dataProvider="dataProvider" :options="multiSortOptions"
                         buttonClass="btn btn-link" @onChange="reload" class="ml-1"></ks-multi-sort>
          <button class="btn ml-1"
              :class="[btnClasses]"
              @click.prevent="filter"
              v-if="showFilter">
            <i :class="[iconClassFilter]" :style="{'float': iconPosition}"></i> {{ labelFilter }}
          </button>
          <button class="btn ml-1"
                  :class="[btnClasses]"
                  @click.prevent="reload"
                  v-if="showReload">
            <i :class="[iconClassReload]" :style="{'float': iconPosition}"></i> {{ labelReload }}
          </button>
          <button :class="[btnClasses]"
                  class="btn btn-danger ml-1"
                  @click.prevent="cancel"
                  v-if="showCancel">
            <i :class="[iconClassCancel]" :style="{'float': iconPosition}"></i> {{ labelCancel }}
          </button>


          <div class="btn-group mr-1" v-if="showMultiSave">
            <button type="button" class="btn" :class="[btnClasses]" @click.prevent="save" style="border-right: 3px solid #ced4da !important;" :disabled="disabledSaveBtn">
              <i :class="[iconClassSave]" :style="{'float': iconPosition}"></i> {{ labelSave }}
            </button>
            <button type="button" class="btn dropdown-toggle dropdown-toggle-split" data-toggle="dropdown"
                    aria-haspopup="true" aria-expanded="false" :class="btnClasses" :disabled="disabledSaveBtn">
              <span class="sr-only">Toggle Dropdown</span>
            </button>
            <div class="dropdown-menu">
              <button class="dropdown-item" v-for="option in multiSaveOptions" @click.prevent="save(option.name)" v-if="option.name" :disabled="disabledSaveBtn">
                {{ option.name }}
              </button>


              <button class="dropdown-item" @click.prevent="save(doNotSaveOption)" v-if="showDiscardOption" :disabled="disabledSaveBtn">
                {{ doNotSaveOption }}
              </button>

              <!--<a class="dropdown-item" href="#">Another action</a>
              <a class="dropdown-item" href="#">Something else here</a>
              <loop class="dropdown-divider"></loop>
              <a class="dropdown-item" href="#">Separated link</a>-->
            </div>
          </div>


          <!--<button class="btn btn-primary ml-1"
                  :class="[btnClasses]"
                  v-if="showMultiSave"
                  v-show="!showMultiSaveOptions"
                  :disabled="disabledSaveBtn"
                  @mouseover="showMultiSaveOptions = true"
          >
            <i :class="[iconClassSave]" :style="{'float': iconPosition}"></i> {{ labelSave }}
          </button>
          <loop v-if="showMultiSave" v-show="showMultiSaveOptions" @mouseleave="showMultiSaveOptions = false">
            <table class="table">
              <tr>
                <button class="btn btn-primary ml-1"
                        :class="[btnClasses]"
                        v-if="showSave"
                        :disabled="true"
                >
                  <i :class="[iconClassSave]" :style="{'float': iconPosition}"></i> {{ labelSave }}
                </button>
              </tr>
              <tr v-for="option in multiSaveOptions" @click="multiSaveClick(option.name)">
                <loop class="btn btn-primary">
                  {{option.name}}
                </loop>
              </tr>
            </table>
          </loop>-->
          <button class="btn ml-1"
                  :class="[btnClasses]"
                  @click.prevent="save"
                  v-if="showSave"
                  :disabled="disabledSaveBtn"
          >
            <i :class="[iconClassSave]" :style="{'float': iconPosition}"></i> {{ labelSave }}
          </button>

          <button class="btn ml-1"
                  :class="[btnClasses]"
                  @click.prevent="edit"
                  v-if="showEdit">
            <i :class="[iconClassEdit]" :style="{'float': iconPosition}"></i> {{ labelEdit }}
          </button>
          <button class="btn ml-1"
                  :class="[btnClasses]"
                  @click.prevent="_new"
                  v-if="showNew"
                  :title="newButtonTitle">
            <i :class="[iconClassNew]" :style="{'float': iconPosition}"></i> {{ labelNew }}
          </button>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
import onMountedDataProvider from '../../mixins/onMountedDataProvider';
export default {
  /**
    tag
    name: ks-data-navigation
    description: mode selector column component 
  **/
  name: 'data-navigation',
  props: {
    /**
      attribute
      name: doNotSaveOption 
      description: doNotSaveOption
    **/
    doNotSaveOption: {
      type: String,
      default: 'Close and Discard'
    },
    /**
      attribute
      name: showDiscardOption 
      description: showDiscardOption
    **/
    showDiscardOption: {
      type: Boolean,
      default: false
    },
    /**
      attribute
      name: navSpinner 
      description: navSpinner
    **/
    navSpinner: {
      type: Boolean,
      default: false
    },
    /**
      attribute
      name: showDefaultFilterSubmit 
      description: showDefaultFilterSubmit
    **/
    showDefaultFilterSubmit:{
      type: Boolean,
      default: false
    },
    /**
      attribute
      name: showDefaultFilterClear 
      description: showDefaultFilterClear
    **/
    showDefaultFilterClear:{
      type: Boolean,
      default: false
    },
    /**
      attribute
      name: iconClassReload 
      description: iconClassReload
    **/
    iconClassReload: {
      type: String,
      default: 'fas fa-sync-alt fa-fw icon'
    },
    /**
      attribute
      name: iconClassFilter 
      description: iconClassFilter
    **/
    iconClassFilter: {
      type: String,
      default: 'fas fa-filter fa-fw icon'
    },
    /**
      attribute
      name: iconClassNew 
      description: iconClassNew
    **/
    iconClassNew: {
      type: String,
      default: 'fas fa-plus fa-fw icon'
    },
    /**
      attribute
      name: iconClassEdit 
      description: iconClassEdit
    **/
    iconClassEdit: {
      type: String,
      default: 'fas fa-edit fa-fw icon'
    },
    /**
      attribute
      name: iconClassSave 
      description: iconClassSave
    **/
    iconClassSave: {
      type: String,
      default: 'fas fa-save fa-fw icon'
    },
    /**
      attribute
      name: iconClassCancel 
      description: iconClassCancel
    **/
    iconClassCancel: {
      type: String,
      default: 'fas fa-ban fa-fw icon'
    },
    /**
      attribute
      name: classes 
      description: classes
    **/
    classes: {
      type: String,
      default: "Save"
    },
    /**
      attribute
      name: size 
      description: size
    **/
    size: {
      type: String,
      default: null
    },
    /**
      attribute
      name: color 
      description: color
    **/
    color: {
      type: String,
      default: ' btn-primary'
    },
    /**
      attribute
      name: disabledSave 
      description: disabledSave
    **/
    disabledSave: {
      type: Boolean,
      default: false
    },
    /**
      attribute
      name: showNavigation 
      description: showNavigation
    **/
    showNavigation: {
      type: Boolean,
      default: false
    },
    /**
      attribute
      name: loadList 
      description: loadList
    **/
    loadList: {
      type: Boolean,
      default: false
    },
    /**
      attribute
      name: showSave 
      description: showSave
    **/
    showSave: {
      type: Boolean,
      default: false
    },
    /**
      attribute
      name: showMultiSave 
      description: showMultiSave
    **/
    showMultiSave: {
      type: Boolean,
      default: false
    },
    /**
      attribute
      name: multiSaveOptions 
      description: multiSaveOptions
    **/
    multiSaveOptions: {
      type: Array,
      default: () => [{'name': 'Save'}]
    },
    /**
      attribute
      name: showCancel 
      description: showCancel
    **/
    showCancel: {
      type: Boolean,
      default: false
    },
    /**
      attribute
      name: showEdit 
      description: showEdit
    **/
    showEdit: {
      type: Boolean,
      default: false
    },
    /**
      attribute
      name: showNew 
      description: showNew
    **/
    showNew: {
      type: Boolean,
      default: false
    },
    /**
      attribute
      name: showFilter 
      description: showFilter
    **/
    showFilter: {
      type: Boolean,
      default: false
    },
    /**
      attribute
      name: showReload 
      description: showReload
    **/
    showReload: {
      type: Boolean,
      default: false
    },
    /**
      attribute
      name: labelSave 
      description: labelSave
    **/
    labelSave: {
      type: String,
      default: "Save"
    },
    /**
      attribute
      name: labelCancel 
      description: labelCancel
    **/
    labelCancel: {
      type: String,
      default: "Cancel"
    },
    /**
      attribute
      name: labelEdit 
      description: labelEdit
    **/
    labelEdit: {
      type: String,
      default: "Edit"
    },
    /**
      attribute
      name: labelNew 
      description: labelNew
    **/
    labelNew: {
      type: String,
      default: "New"
    },
    /**
      attribute
      name: labelFilter 
      description: labelFilter
    **/
    labelFilter: {
      type: String,
      default: "Filter"
    },
    /**
      attribute
      name: labelReload 
      description: labelReload
    **/
    labelReload: {
      type: String,
      default: "Reload"
    },
    /**
      attribute
      name: dataProvider 
      description: dataProvider
    **/
    dataProvider: {
      required: true,
      default: null
    },
    /**
      attribute
      name: pageSizes 
      description: pageSizes
    **/
    pageSizes: {
      type: Array,
      default: () => []
    },
    /**
      attribute
      name: showMultiSort 
      description: showMultiSort
    **/
    showMultiSort: {
      type: Boolean,
      default: false
    },
    /**
      attribute
      name: multiSortOptions 
      description: multiSortOptions
    **/
    multiSortOptions: {
      type: Array,
      default: () => []
    },
    /**
      attribute
      name: round 
      description: round
    **/
    round: {
      type: Boolean,
      default: false
    },
    /**
      attribute
      name: newButtonTitle 
      description: newButtonTitle
    **/
    newButtonTitle: {
      type: String,
      default: null
    },
    /**
      attribute
      name: iconPosition 
      description: iconPosition
    **/
    iconPosition: {
      type: String,
      default: 'left'
    },
    /**
      attribute
      name: showErrors 
      description: showErrors
    **/
    showErrors:{
      type: Boolean,
      default: true
    }
  },
  mixins: [onMountedDataProvider],
  computed: {
    filter_options(){
      return this.data_provider_ref.filter_options;
    },
    screenSizeId() {
      return app.layout.screenSizeId;
    },
    current_page() {
      return this.data_provider_ref.current_page;
    },
    btnClasses() {
      let size = `${this.size ? `btn-${this.size}` : ''}`;
      let shape = `${this.round ? ` round` : ''}`
      let color = ` ${this.color}`
      return size + shape + color;
    },
    prevPageEnable() {
      return this.data_provider_ref.current_page > 0;
    },
    nextPageEnable() {
      return this.data_provider_ref.current_page + 1 < this.data_provider_ref.total_pages;
    }
  },
  methods: {
    setErrors(errors){
      if(this.showErrors && Array.isArray(errors)){
        this.errs = errors;
        setTimeout(() => {
          this.errs = []
        },30000)
      }
    },
    cancel() {
      this.errs = [];
      this.data_provider_ref.cancel_record(this);
    },
    save(option = null) {
      if (this.navSpinner) {
        //this.$refs.ref_loading_data_nav.show();
        //setTimeout(() => this.$refs.ref_loading_data_nav.hide(), 500);
      }
      if (option !== this.doNotSaveOption) {
        this.data_provider_ref.save_record(this, option);
      } else {
        this.$emit('discardAndClose');
      }

    },
    edit() {
      this.data_provider_ref.edit_record(this);
    },
    _new() {
      this.data_provider_ref.new_record(this);
    },
    /* 
      Filter method:
      customFilters object with custom Filters , clearDepp two options (all,default) 'all' remove all filters and  'default' restore default filters 
    */
    filter(customFilters = null, clearDeep = null) {
      this.data_provider_ref.filter_list(customFilters, clearDeep, this);
      if(this.screenSizeId < 3){
        app.closeLeftDrawer();
      }
      this.$emit(`onFilterSubmit`, this);
    },
    clear(){
      this.data_provider_ref.filter_list(null, 'all', this);
      this.$emit(`onFilterClear`, this);
    },
    reload() {
      //this.data_provider_ref.load_data(this, this.loadList);
      this.data_provider_ref.setCurrentPage(0, true);
      if (this.screenSizeId < 3) {
        app.closeLeftDrawer();
        app.closeRightDrawer();
      }
    },
    changePageSize() {
      this.data_provider_ref.setRecordsPerPage(this.page_size, true);
    },
    prevPage() {
      if (this.current_page > 0){
        this.data_provider_ref.setCurrentPage(this.current_page - 1, true);
      }
    },
    firstPage() {
      this.data_provider_ref.setCurrentPage(0, true);
    },
    lastPage() {
      this.data_provider_ref.setCurrentPage(this.data_provider_ref.total_pages - 1, true);
    },
    nextPage() {
      if ((this.current_page + 1) < this.data_provider_ref.total_pages) {
        this.data_provider_ref.setCurrentPage(this.current_page + 1, true);
      }
    }
  },
  async mounted() {
    await this.onMountedDataProvider();
    if (!this.pageSizes.includes(this.data_provider_ref.records_per_page)) {
      this.pageSizes.push(this.data_provider_ref.records_per_page);
    }
    this.page_size = this.data_provider_ref.records_per_page;
  },
  data() {
    return {
      showMultiSaveOptions: false,
      page_size: 0,
      disabledSaveBtn: this.disabledSave,
      dataProvidersRef: app.dataproviders,
      errs:[]
    }
  }
}
</script>
<style scoped>
.round {
  border-radius: 50% !important;
  padding: 6px !important;
}

.icon {
  margin: 4px 5px 0 5px;
}
</style>
